<template>
  <div>
    <div class="register_box">
      <div class="register">
        <div class="login_title">注册账户</div>
        <div class="login_input">
          <el-form
            :model="formInline"
            :rules="rules"
            ref="userForm"
            label-width=" 105px"
            label-position="right"
          >
            <el-form-item prop="area" label="地区">
              <el-select v-model="formInline.area" placeholder="请选择地区">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="unit_name" label="单位名称">
              <el-input auto-complete="new-password"
                v-model="formInline.unit_name"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="credit_code" label="信用代码">
              <el-input auto-complete="new-password"
                v-model="formInline.credit_code"
                placeholder="请输入信用代码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mobile" label="手机号">
              <el-input auto-complete="new-password"
                v-model="formInline.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="email" label="邮箱">
              <el-input auto-complete="new-password"
                v-model="formInline.email"
                placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input auto-complete="new-password"
                v-model="formInline.password"
                show-password
                placeholder="请输入密码（6-12位数字、字母）"
              ><!--禁用自动填充密码-->
<input type="text" placeholder="请输账户" class="fake-input"/>
<input type="password" placeholder="请输密码" class="fake-input"/>
</el-input>
            </el-form-item>
            <el-form-item prop="repassword" label="密码">
              <el-input auto-complete="new-password"
                v-model="formInline.repassword"
                show-password
                placeholder="请再次输入密码（6-12位数字、字母）"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code" label="验证码">
              <el-input auto-complete="new-password"
                v-model="formInline.code"
                placeholder="请输入验证码"
              ></el-input>
              <div class="code_box">
                <p style="cursor: pointer" @click="check()" v-if="isSend">
                  {{ sendmsg }}
                </p>
                <p v-if="!isSend" style="color: #fff">{{ sendmsg }}</p>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="th_text">
          <div class="ts_tiem_left">
            <el-radio
              @click.native.prevent="clickitem()"
              v-model="radio"
              :label="true"
              ><span style="display: none">1</span></el-radio
            >我已阅读并接受<span style="color: #1954a4; cursor: pointer">
              <span @click="xy('1')">《用户协议》</span
              ><span @click="xy('2')">《隐私协议》</span></span
            >
          </div>
          <div class="ts_tiem">
            已有账号
            <span
              style="color: #1954a4; cursor: pointer"
              @click="jump('/login')"
              >去登录></span
            >
          </div>
        </div>
        <div class="login_button_box" @click="signIn">
          <div class="login_button_text">注册</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    //手机号校验
    let checkPhone = (rule, value, callback) => {
      let reg = /^1[345789]\d{9}$/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    };
    //密码校验

    let valiPass = (rule, value, callback) => {
      let reg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,12}$/;
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("大于6位小于12位，由字母和数字组成"));
      } else {
        callback();
      }
    };
    //确认密码校验
    let validatePass = (rule, value, callback) => {
      let reg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,12}$/;
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次输入密码不一致!"));
      } else if (!reg.test(value)) {
        callback(new Error("大于6位小于12位，由字母和数字组成"));
      } else {
        callback();
      }
    };
    return {
      radio: false,
      formInline: {
        area: "",
        unit_name: "",
        credit_code: "",
        mobile: "",
        email: "",
        code: "",
        password: "",
        repassword: "",
      },
      options: [
        {
          value: "河南",
          label: "河南",
        },
      ],
      rules: {
        area: [
          {
            required: true,
            message: "请选择所在地区（仅限河南省）",
            trigger: "change",
          },
        ],
        unit_name: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        credit_code: [
          { required: true, message: "请输入统一信用代码", trigger: "blur" },
        ],
        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, validator: valiPass, trigger: "blur" }],
        repassword: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      }, //校验规则
      //手机验证码
      timer: 0,
      sendmsg: "发送验证码",
      isSend: true,
    };
  },
  mounted() {},
  methods: {
    //跳转页面
    jump(e) {
      this.$router.push(e);
    },
    //查看协议
    xy(e) {
      let url = "";
      if (e == 1) {
        url = "institution/config/getUserxy";
      } else {
        url = "institution/config/getprivacy";
      }
      let that = this;
      let data = {};
      that.$http.post(url, data).then((res) => {
        if (res.code == 1) {
          this.$alert(res.data.value, {
            dangerouslyUseHTMLString: true,
            showClose: false,
            customClass: "xy",
          });
        }
      });
    },
    //同意协议
    clickitem(e) {
      this.radio = !this.radio;
    },
    /**
     * 手机发送验证码
     */
    check() {
      let that = this;
      that.$refs["userForm"].validateField("email", (mobileError) => {
        if (!mobileError) {
          let data = {
            email: that.formInline.email,
          };
          // console.log(data);
          that.$http.post("ems/send", data).then((res) => {
            that.$self.ts(res).then((data) => {
              this.isSend = false;
              this.timer = 60;
              this.sendmsg = this.timer + "s";
              this.timeFun = setInterval(() => {
                --this.timer;
                this.sendmsg = this.timer + "s";
                if (this.timer == 0) {
                  this.isSend = true;
                  this.sendmsg = "重新发送";
                  clearInterval(this.timeFun);
                }
              }, 1000);
            });
          });
        }
      });
    },
    //注册
    signIn() {
      let that = this;

      that.$refs["userForm"].validate((valid) => {
        if (valid) {
          if (that.radio == false) {
            this.$message.error("请先阅读并勾选协议！");
            return;
          }
          let data = that.formInline;
          // console.log(data);
          that.$http.post("ins_user/register", data).then((res) => {
            that.$self
              .ts(res)
              .then((data) => {
                this.$alert(
                  "您已提交注册，请耐心等待平台审核审核结果将邮箱通知您",
                  "温馨提示",
                  {
                    confirmButtonText: "返回首页",
                    customClass: "zu",
                    showClose: false,
                    callback: (action) => {
                      this.$router.push("/login");
                    },
                  }
                );
              })
              .catch((err) => {
                this.timer == 0;
                this.isSend = true;
                this.sendmsg = "重新发送";
                clearInterval(this.timeFun);
              });
          });
        } else {
        }
      });
    },
  },
};
</script>
<style>
.xy {
  width: 50%;
  height: 85%;
  overflow: auto !important;
}

.zu .el-message-box {
  width: 300px !important;
  /* height: 298px; */
}
.zu .el-message-box__title {
  text-align: center;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #29469a;
}
.zu .el-message-box__message {
  margin: 59px auto;
  width: 288px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  text-align: center;
}
.zu .el-message-box__btns .el-button {
  width: 340px;
  height: 40px;
  background: #29469a;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}
/* 滚动条样式,隐藏 */
.xy::-webkit-scrollbar {
  width: 0px;
}

.xy::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0);
}

.xy .el-button--small {
  padding: 12px 28px;
  font-size: 15px;
  border-radius: 3px;
}
</style>
<style scoped>
.register_box {
  padding: 0.8875rem 0 1.0375rem;
}

.register {
  width: 9.5rem;
  background: #ffffff;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px 6px 0px 6px;
  margin: auto;
  padding: 0.4875rem 1rem 0.375rem;
  box-sizing: border-box;
}

.login_title {
  font-size: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
}

.login_input {
  margin-top: 0.3625rem;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-form-item {
  border: 1px solid #e6e6e6;
  background: #fafcfd;
}

::v-deep .el-form-item__label {
  position: relative;
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333 !important;
}

::v-deep .el-form-item__label::after {
  position: absolute;
  content: "";
  top: 11px;
  right: 0px;
  width: 1px;
  height: 19px;
  background: #999999;
  opacity: 0.32;
}

::v-deep .el-input__inner {
  border: none;
  background: #fafcfd;
}

::v-deep .el-input .el-input__inner::placeholder {
  color: #999999 !important;
}

.code_box {
  width: 150px;
  background: #1954a4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}

::v-deep .el-radio__inner {
  border-radius: 30%;
}

::v-deep .el-radio {
  margin-right: 0px;
}

.th_text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ts_tiem_left {
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.ts_tiem {
  font-size: 0.175rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.login_button_box {
  width: 7.5rem;
  height: 0.55rem;
  background: rgba(25, 84, 164, 1);
  text-align: center;
  line-height: 0.55rem;
  margin-top: 0.375rem;
  cursor: pointer;
}

.login_button_box:hover {
  /* background: #0939ca; */
}

.login_button_text {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>
  